import React from 'react' 
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "./AssetsHelpers";

export const sortCaret = (order, column) => {
  return (
    <>
      <div className="sort_wrap">
        <div className={` ${order === "desc" ? "upactive" : "up"}`}></div>
        <div className={` ${order === "asc" ? "downactive" : "down"}`}></div>
      </div>
    </>
  );
};

export const sortCaret2 = (order, column) => {
  return (
    <>
      <span
        className={`svg-icon svg-icon-sm ${
          order === "desc" ? "svg-icon-primary" : ""
        } ml-1`}
      >
        <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Up-2.svg")} />
      </span>
      <br />
      <span
        className={`svg-icon svg-icon-sm ${
          order === "asc" ? "svg-icon-primary" : ""
        } ml-1`}
      >
        <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Down-2.svg")} />
      </span>
    </>
  );
};

export const headerSortingClasses = (
  column,
  sortOrder,
  isLastSorting,
  colIndex
) => (sortOrder === "asc" || sortOrder === "desc" ? "sortable-active" : "");
